import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { FiDownload } from 'react-icons/fi'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalRotaEntrega from './ModalRotaEntrega'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as RotaEntregaHttp from '../../../../services/api/https/registration/rota-entrega.http'

function RotasEntrega({ selectedTp, dispatch, history }) {
  // Vars
  const novaRota = { nome: '', ativo: 1, id: null }
  const INIT_STATE = {
    showModal: false,
    modalData: novaRota,
    rotas: [],
  }

  // Hooks
  const [state, setState] = useState(INIT_STATE)
  useEffect(() => {
    if (selectedTp === 0) dispatch(showMessageBox(null, errorHandler('Selecione um TP')))
    else _fetch()
  }, [selectedTp])

  // Events
  const onModalResponse = async (type, payload) => {
    try {
      if (type === 'error') throw new Error(payload)
      else {
        dispatch(showLoadingBox('Aguarde', 'Salvando Rota ...'))
        if (selectedTp === 0) throw new Error('Selecione o Operador Logístico.')
        const fetchedRotas = await RotaEntregaHttp.salvarRotaEntrega(payload, selectedTp)
        setState({ ...state, rotas: fetchedRotas, showModal: false })
        dispatch(showMessageBox('Operação Realizada com Sucesso', null))
      }
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  // Helpers
  const _fetch = async () => {
    try {
      dispatch(showLoadingBox('Aguarde', 'Carregando as Rotas ...'))
      const fetchedRotas = await RotaEntregaHttp.getRotasEntrega(selectedTp)
      setState({ ...state, rotas: fetchedRotas })
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onExportarClick = async () => {
    try {
      if (selectedTp === 0) throw new Error('Selecione o Operador Logístico.')
      await RotaEntregaHttp.exportarClientesRotasEntrega(selectedTp)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  //Render
  return (
    <div>
      <PageHeader>2.6 - Rotas de Entrega</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => setState({ ...state, showModal: true, modalData: novaRota })}
          onVoltar={history.goBack}
        >
          <div style={{ marginBottom: 15 }}>
            <Btn onClick={onExportarClick}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <FiDownload size={18} />
                <span style={{ marginLeft: 5 }}>Exportar</span>
              </div>
            </Btn>
          </div>
          <RotaDataTable
            rotas={state.rotas}
            onRowSelected={rota => setState({ ...state, showModal: true, modalData: rota })}
          />
        </CustomPanel>
      </div>
      <ModalRotaEntrega
        rota={state.modalData}
        isVisible={state.showModal}
        onClose={() => setState({ ...state, showModal: false })}
        onResponse={onModalResponse}
      />
    </div>
  )
}

const RotaDataTable = React.memo(function ({ rotas, onRowSelected }) {
  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')
  // Render
  return (
    <div>
      <DataTable
        value={rotas}
        emptyMessage={'Não existe Rota de Entrega Cadastrada'}
        selectionMode="single"
        onSelectionChange={e => onRowSelected(e.value)}
        header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
        globalFilter={globalFilter}
      >
        <Column field={'nome'} header={'Rota'} />
        <Column
          style={tableCellCentered(80)}
          field={'ativo'}
          header={'Ativo'}
          body={rota => <CustomCheckbox checked={rota.ativo === 1} disabled={true} />}
        />
      </DataTable>
    </div>
  )
})

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(RotasEntrega))
